import React from 'react';
import { Column } from 'Shared/components';
import { useAppContext } from 'QuoteApp/services/providers';
import { NoResults } from '../../NoResults';
import { ReportDetailHeaderRow } from '../../ReportDetailHeaderRow';
import { ViolationForm } from './ViolationForm';
import { DriverReportType } from '../../types';
import { useQuoteAppFeatureFlags } from 'QuoteApp/utils/hooks/useQuoteAppFeatureFlags';

export const ViolationReport: DriverReportType = ({ driverId }) => {
  const { details } = useAppContext();
  const { collectDayOfAccidentFlag } = useQuoteAppFeatureFlags();
  const violations = details.drivers[driverId].violations;
  const canChallenge = Object.keys(
    details.commands.drivers[driverId].violations
  ).some((id) =>
    details.commands.drivers[driverId].violations[id].some(
      (c) => c.name === 'challenge_violation'
    )
  );

  return (
    <>
      <ReportDetailHeaderRow canChallenge={canChallenge} includeRemove>
        <Column variant="quarter">Month</Column>
        {collectDayOfAccidentFlag && <Column variant="quarter">Day</Column>}
        <Column variant="quarter">Year</Column>
        <Column variant="half">Description</Column>
      </ReportDetailHeaderRow>
      {Object.keys(violations).length ? (
        <ul>
          {Object.values(violations).map(({ identifier }) => (
            <ViolationForm
              key={identifier}
              driverId={driverId}
              incidentId={identifier}
              canChallenge={canChallenge}
            />
          ))}
        </ul>
      ) : null}
      <NoResults isVisible={!Object.keys(violations).length}>
        No violations discovered
      </NoResults>
    </>
  );
};
